import axios from "axios";
import { createURL } from "./client";

// getCoinPackages получает список доступных наборов монет
export async function getCoinPackages() {
    return await axios.get(createURL("/api/payments/packages"));
}

// initiatePurchase инициирует процесс покупки монет
export async function initiatePurchase(packageId) {
    return await axios.post(createURL("/api/payments/initiate"), { packageId });
}

// processVKPayment обрабатывает платеж через VK
export async function processVKPayment(paymentData) {
    return await axios.post(createURL("/api/payments/vk-process"), paymentData);
}

// getPaymentStatus получает статус платежа
export async function getPaymentStatus(paymentId) {
    return await axios.get(createURL("/api/payments/status/" + paymentId));
}